import { Box, Typography, ListItemButton } from '@mui/material';
import { CollapseIcon, ExpandIcon } from '../../utils/icons';
import type { MenuSection } from '../../types';
import { capitalDesignTokens } from '@opengov/capital-mui-theme';
import { getMenuSectionTestId } from '../../constants';
interface SectionHeaderProps {
  section: MenuSection;
  isExpanded: boolean;
  onToggle?: () => void;
}

export function SectionHeader({ section, isExpanded, onToggle }: SectionHeaderProps) {
  if (section.collapsible) {
    return (
      <ListItemButton
        data-testid={getMenuSectionTestId(section.id)}
        onClick={onToggle}
        disableRipple
        aria-expanded={isExpanded}
        sx={{
          px: 2,
          py: 0.5,
          minHeight: 32,
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            gap: 0.5,
          }}
        >
          {isExpanded ? (
            <CollapseIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          ) : (
            <ExpandIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          )}
          <Typography
            variant="subtitle2"
            component="h2"
            sx={{
              color: `${capitalDesignTokens.foundations.colors.gray700}`,
            }}
          >
            {section.title}
          </Typography>
        </Box>
      </ListItemButton>
    );
  }

  return (
    <Box data-testid={getMenuSectionTestId(section.id)} sx={{ px: 2, py: 0.5, mb: 0.5 }}>
      <Typography
        variant="subtitle2"
        component="h2"
        sx={{ color: `${capitalDesignTokens.foundations.colors.gray700}` }}
      >
        {section.title}
      </Typography>
    </Box>
  );
}
